import { SubscriptionEvent } from 'nekst-api';

export function useSubscriptionEventHelper() {
  const getLabel = (type: SubscriptionEvent) => {
    const map = {
      [SubscriptionEvent.PROJECT_CREATED]: 'Transaction Created',
      [SubscriptionEvent.PROJECT_UPDATED]: 'Transaction Updated',
      [SubscriptionEvent.CONTACT_CREATED]: 'Contact Created',
      [SubscriptionEvent.CONTACT_UPDATED]: 'Contact Updated',
      [SubscriptionEvent.CONTACT_DELETED]: 'Contact Deleted',
      [SubscriptionEvent.EMAIL_SENT]: 'Email Message Sent',
      [SubscriptionEvent.SMS_SENT]: 'SMS Message Sent',
      [SubscriptionEvent.PROJECT_NOTE_CREATED]: 'Transaction Note Created',
      [SubscriptionEvent.PROJECT_NOTE_UPDATED]: 'Transaction Note Updated',
      [SubscriptionEvent.CONTACT_NOTE_CREATED]: 'Contact Note Created',
      [SubscriptionEvent.CONTACT_NOTE_UPDATED]: 'Contact Note Updated',
    };

    return map[type];
  };

  return {
    getLabel,
  };
} 